import { motion } from 'framer-motion';
import img1 from '../assets/IMG_0493.jpg'; // Red bride smiling at night
import img2 from '../assets/IMG_0504.jpg'; // Black saree, moody editorial
import img3 from '../assets/IMG_0498.jpg'; // Red bride traditional
import img4 from '../assets/IMG_0505.jpg'; // Orange bride jewellery
import img5 from '../assets/IMG_0501.jpg'; // Bride entering with flowers
import img6 from '../assets/IMG_0506.jpg'; // Traditional bride white flowers
import img7 from '../assets/IMG_0500.jpg'; // Night ceremony wide
import img8 from '../assets/IMG_0507.jpg'; // Couple at reception
import styles from './Gallery.module.css';

const IMAGES = [
  { src: img1, alt: 'Bridal makeup by Shobha Ma\'am — red lehenga bride, Bharatpur', tall: true },
  { src: img2, alt: 'Editorial party look by Shobha Salon — black saree styling', tall: false },
  { src: img3, alt: 'Traditional bridal makeup — Shobha Beauty Parlour Bharatpur', tall: false },
  { src: img4, alt: 'Bridal jewellery and makeup closeup — best makeup artist Bharatpur', tall: true },
  { src: img5, alt: 'Bride entering wedding ceremony — Shobha Salon destination bridal', tall: false },
  { src: img6, alt: 'Traditional bride with white flowers — Shobha Beauty Parlour', tall: false },
  { src: img7, alt: 'Wedding night ceremony — Shobha Salon Bharatpur destination bridal', tall: true },
  { src: img8, alt: 'Couple at wedding reception — Shobha Salon Bharatpur', tall: false },
];

export default function Gallery() {
  return (
    <section id="gallery" className={styles.gallery}>
      <div className={styles.inner}>

        {/* Heading */}
        <motion.div
          className={styles.heading}
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.75 }}
        >
          <span className={styles.headingTag}>Real Work · Real Brides</span>
          <h2 className={styles.headingTitle}>The Work Speaks</h2>
          <p className={styles.headingSub}>Every image from @shobha.salon</p>
        </motion.div>

        {/* Masonry grid */}
        <div className={styles.masonry}>
          {IMAGES.map((img, i) => (
            <motion.a
              key={img.src}
              href="https://www.instagram.com/shobha.salon/"
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles.item} ${img.tall ? styles.tall : ''}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.08 }}
              transition={{ duration: 0.65, delay: (i % 3) * 0.07 }}
            >
              <img src={img.src} alt={img.alt} loading="lazy" />
              <div className={styles.itemOverlay}>
                <span className={styles.itemLabel}>✦ View on Instagram</span>
              </div>
            </motion.a>
          ))}
        </div>

        {/* Follow CTA */}
        <motion.div
          className={styles.followWrap}
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <a
            href="https://www.instagram.com/shobha.salon/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.followBtn}
          >
            Follow @shobha.salon · 31K+ Followers →
          </a>
        </motion.div>
      </div>
    </section>
  );
}
